import { Component, Input, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NotificationsService, PGNotification } from '../../services/notifications.service';
import { DataService } from '../../services/data.service';
import { PgNotificationComponent } from '../../pg-ui-elements/pg-notification/pg-notification.component';

@Component({
    selector: 'app-pg-notification-list',
    templateUrl: './pg-notification-list.component.html',
    styleUrls: ['./pg-notification-list.component.scss'],
    standalone: false
})
export class PgNotificationListComponent implements OnInit, OnDestroy {
    
    constructor(private dataService:DataService, private notificationService:NotificationsService) { }

    @Input() markAsReadOnDestroy:boolean;

    pageLimit = 10;
    
    notifications:Array<PGNotification> = null;
    currentPage = -1;
    isAtEnd = false;
    isLoading = false;

    ngOnInit(): void {
        this.reset();
    }

    reset() {
        this.notifications = [];
        this.currentPage = -1;
        this.isAtEnd = false;
        this.isLoading = true;

        this.checkLoad();
    }

    checkLoad() {
        if(!this.isAtEnd) {
            this.currentPage++;
            this.isLoading = true;

            this.dataService.getNotifications({ 
                offset: this.currentPage * this.pageLimit,
                limit: this.pageLimit + 1
            }).subscribe((data) => {
                this.isLoading = false;
                if(data.length < this.pageLimit + 1) this.isAtEnd = true;

                for(let i = 0; i < this.pageLimit && i < data.length; i++) {
                    if(data[i].deadline == null || new Date(data[i].deadline).getTime() > Date.now()) {
                        this.notifications.push(new PGNotification(data[i]))
                    }
                }
            }, () => {
                this.isAtEnd = true;
                this.isLoading = false;
            })
        }
    }

    ngOnDestroy() {
        if(this.markAsReadOnDestroy) this.markAsRead()
    }

    @ViewChildren(PgNotificationComponent) notificationComponents:QueryList<PgNotificationComponent>

    markAsRead() {
        let _markAsRead:Array<string> = [];

        for(let _notification of this.notifications) {
            if(_notification.status != 'read') {
                _markAsRead.push(_notification.id)
            }
        }

        this.notificationComponents.forEach((item) => {
            if(item.childNotifications != null) {
                for(let _notification of item.childNotifications) {
                    if(_notification.status != 'read') {
                        _markAsRead.push(_notification.id)
                        _notification.status = 'read'
                    }
                }
            }
        })

        if(_markAsRead.length > 0) {
            this.notificationService.markAsRead(_markAsRead)
        }
    }
}
